module.exports = __webpack_public_path__ + "58c0a459105db63184cf720a3484bfe8.svg";